import { render, staticRenderFns } from "./WillOtherAssetsDetails.vue?vue&type=template&id=f4cf34f2"
import script from "./WillOtherAssetsDetails.vue?vue&type=script&lang=js"
export * from "./WillOtherAssetsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports